import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  restaurantId: 0,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')

    return systemSettingApi.getCartCalculationSetting()
      .then(({ data }) => commit('SETTING_FETCHED', data))
      .catch(err => commit('SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateCartCalculationSetting({ restaurantId: state.restaurantId || 0 })
      .then(() => commit('SETTING_UPDATED'))
      .catch(error => {
        commit('SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  SETTING_FETCHED(state, data) {
    state.restaurantId = data.restaurantId
  },
  SETTING_FETCH_FAILED() {
    store.dispatch('message/error', 'Не удалось прочитать настройку')
  },
  SETTING_UPDATED() {
    store.dispatch('message/success', 'Настройка сохранена')
  },
  SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'Не удалось сохранить настройку')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
